<template>
    <div>
        <p v-if="data.organisation"><strong>Организация:</strong> {{ data.organisation }}</p>
        <p v-if="data.startDate"><strong>Дата начала:</strong> {{ getFormattedDate(data.startDate) }}</p>
        <p v-if="data.finishDate || data.isUntilNow"><strong>Дата окончания:</strong> {{ data.finishDate
            ? getFormattedDate(data.finishDate)
            : data.isUntilNow
                ? "По настоящее время"
                : "" }}</p>
        <p v-if="data.position"><strong>Должность:</strong> {{ data.position }}</p>
        <p v-if="data.region && data.region.value"><strong>Регион:</strong> {{ data.region.value }}</p>
        <p v-if="data.employerSite"><strong>Сайт работодателя:</strong> {{ data.employerSite }}</p>
        <p v-if="data.positionLevel"><strong>Уровень должности:</strong> {{ data.positionLevel }}</p>
        <p v-if="data.workersNumber"><strong>Количество сотрудников в организации:</strong> {{ data.workersNumber}} </p>
        <p v-if="data.responsibilities"><strong>Обязанности:</strong> {{ data.responsibilities }}</p>
    </div>
</template>

<script>
import {getFormattedDate} from "@/tools/moment-date";

export default {
    name: "ExpertPanelReviewAboutCareer",
    methods: {
        getFormattedDate,
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>

</style>